import { render, staticRenderFns } from "./FootballStats.vue?vue&type=template&id=3dcb5a4c&scoped=true&"
import script from "./FootballStats.vue?vue&type=script&lang=js&"
export * from "./FootballStats.vue?vue&type=script&lang=js&"
import style0 from "./FootballStats.vue?vue&type=style&index=0&id=3dcb5a4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb5a4c",
  null
  
)

export default component.exports